module.exports = __webpack_public_path__ + "static/tableH.2e6e4261.png";